import isEmpty from 'lodash-es/isEmpty';

export const isNotEmptyObject = <T>(obj: T | Record<string, never>): obj is T => {
  return !isEmpty(obj);
};
